module.exports = __webpack_public_path__ + "static/espasol-34b0519f0de31964f7672983ec2d87c6.jpg";